export type AvatarSize = "sm" | "md" | "lg" | "xl";

export const AVATAR_SIZE_CLASS_MAP: Record<AvatarSize, string> = {
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-12 w-12",
  xl: "h-16 w-16",
};

export const INITIALS_SIZE_CLASS_MAP: Record<AvatarSize, string> = {
  sm: "text-xs",
  md: "text-sm",
  lg: "text-md",
  xl: "text-xl",
};
